import JsonFieldfadc8 from "./components/json/JsonField";
export const CustomViewComponentsMap: any = {
    'customview.json/JsonField': JsonFieldfadc8,
}